import { useEffect, useState, useRef } from "react";
import styles from "../../../styles/aprt.module.scss";

function PlanRendererInfoMode({
  svgContent,
  selectedCompartmentInd,
  hoveredCompartmentInd,
  setApartmentViewInteractions,
}) {
  const [modifiedSvgContent, setModifiedSvgContent] = useState(svgContent);
  const svgContainerRef = useRef(null);

  useEffect(() => {
    //TODO: now that i change the colors in parent component to we need this useEffect for anything?
    //TODO: check if not merge with useEffect to add listeners to paths
    if (!svgContent) return;

    const parser = new DOMParser();
    const svgDoc = parser.parseFromString(svgContent, "image/svg+xml");
    const svgRoot = svgDoc.documentElement;

    /*
removed color fill changes as its done in parent component
*/

    const serializer = new XMLSerializer();
    const newSvgContent = serializer.serializeToString(svgDoc);
    setModifiedSvgContent(newSvgContent);
  }, [svgContent]);

  const handleRoomHover = (ind, isOnPath) => {
    //TODO: move this to utils
    ind === null
      ? setApartmentViewInteractions(
          ({ isCompartmentPathHovered, hoveredCompartmentInd, ...rest }) => ({
            isCompartmentPathHovered: false,
            hoveredCompartmentInd: null,
            ...rest,
          })
        )
      : setApartmentViewInteractions(
          ({ isCompartmentPathHovered, hoveredCompartmentInd, ...rest }) => ({
            isCompartmentPathHovered: isOnPath,
            hoveredCompartmentInd: ind,
            ...rest,
          })
        );
  };
  const handleRoomClick = (ind) => {
    !ind
      ? setApartmentViewInteractions(({ selectedCompartmentInd, ...rest }) => ({
          selectedCompartmentInd: null,
          ...rest,
        }))
      : setApartmentViewInteractions(({ selectedCompartmentInd, ...rest }) => ({
          selectedCompartmentInd: ind,
          ...rest,
        }));
  };
  useEffect(() => {
    //TODO: check if not merge with above useEffect[svgContent]
    const svgContainer = svgContainerRef.current;
    if (!svgContainer) return;

    const compartmentGroup = svgContainer.querySelector(".compartments");
    const compartmentPaths = compartmentGroup.querySelectorAll(".compartment");

    compartmentPaths.forEach((path) => {
      const compartmentNumber = Number(path.getAttribute("number"));
      //TODO: test listeners on mobile devices, maybe use onTouchStart instead of onClick
      path.addEventListener("click", () => handleRoomClick(compartmentNumber));
      path.addEventListener("mouseenter", () =>
        handleRoomHover(compartmentNumber, true)
      );
      path.addEventListener("mouseleave", () => handleRoomHover(null, false));
    });

    return () => {
      compartmentPaths.forEach((path) => {
        const compartmentNumber = Number(path.getAttribute("number"));
        path.removeEventListener("click", () =>
          handleRoomClick(compartmentNumber)
        );
        path.removeEventListener(
          "mouseenter",
          handleRoomHover(compartmentNumber, true)
        );
        path.removeEventListener("mouseleave", handleRoomHover(null, false));
      });
    };
  }, [modifiedSvgContent]);

  useEffect(() => {
    //TODO: check if not merge with above useEffect[svgContent]
    const svgContainer = svgContainerRef.current;
    if (!svgContainer) return;

    const compartmentGroup = svgContainer.querySelector(".compartments");
    const compartmentPaths = compartmentGroup.querySelectorAll(".compartment");

    compartmentPaths.forEach((path) => {
      const compartmentNumber = Number(path.getAttribute("number"));
      //TODO: test listeners on mobile devices, maybe use onTouchStart instead of onClick
      if (compartmentNumber === selectedCompartmentInd || compartmentNumber === hoveredCompartmentInd) {
        path.classList.add(`${styles.svg_path_highlighted}`);
      }
      if (compartmentNumber != selectedCompartmentInd && compartmentNumber != hoveredCompartmentInd) {
        path.classList.remove(`${styles.svg_path_highlighted}`);
      }
    });

  }, [selectedCompartmentInd, hoveredCompartmentInd]);

  return (
    <div
      ref={svgContainerRef}
      style={{
        height: "100%",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
      dangerouslySetInnerHTML={{ __html: modifiedSvgContent }}
    />
  );
}

export default PlanRendererInfoMode;
